<template>
    <div class="sync-legacy-page">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading"/>
        </transition>
        <div class="text-center">
            <a class="btn btn-secondary btn-sm mr-4" href="/espace-employes/sync">
                <i class="fad fa-arrow-circle-left"></i>
                Retour accueil<br/>
                Synchronisation
            </a>
            Synchroniser
            <span class="text-info">Cérès</span>
            vers :
            <div class="btn-group" role="group">
                <button class="btn btn-dark btn-sm" v-for="(nameList, key) in syncList" @click="syncNow(key)"
                        :disabled="loading">
                    <i :class="loading && typeLoading === key ? 'fad fa-sync fa-spin' : 'fad fa-sync'"></i>
                    <span v-for="line in nameList">
                        {{ line }}<br/>
                    </span>
                </button>
            </div>
        </div>
        <div class="text-center mt-4 mb-4">
            <button class="btn btn-primary btn-sm" @click="showProducts()" :disabled="loading">
                <i :class="loading && typeLoading === 'products' ? 'fad fa-spinner fa-pulse' : 'fad fa-search'"></i>
                Afficher le tableau<br/>récapitulatif des produits
            </button>
        </div>
        <template v-if="errors">
            <div class="card card-body">
                <div class="alert alert-danger">
                    <div v-if="typeLoading !== 'products'">
                        Synchronisation Cérès vers {{ syncList[typeLoading].join(' ') }} : Une erreur est survenue
                        pendant la synchronisation
                    </div>
                    <div v-if="typeLoading === 'products'">
                        Affichage des produits depuis Cérès : Une erreur est survenue
                    </div>
                </div>
                <ErrorsZone :errors="errors"/>
            </div>
        </template>
        <template v-if="loading">
            <div class="card card-body">
                <div v-if="typeLoading !== 'products'">
                    <i class="fad fa-sync fa-spin"></i>
                    Synchronisation Cérès vers {{ syncList[typeLoading].join(' ') }} en cours, merci de patienter...
                </div>
                <div v-if="typeLoading === 'products'">
                    <i class="fad fa-sync fa-spin"></i>
                    Affichage des produits depuis Cérès, merci de patienter...
                </div>
            </div>
        </template>
        <template v-if="syncResponse && !errors">
            <div class="card card-body">
                <div v-if="syncResponse.actions && syncResponse.actions.products && !syncResponse.actions.products._error">
                    <div class="alert alert-success">
                        Synchronisation Cérès vers {{ syncList[typeLoading].join(' ') }} : Synchronisation
                        terminée avec succès.
                    </div>
                    Actions effectuées pendant la synchronisation : <br/>
                    <div class="card" style="background-color: #fafafa">
                        <json-viewer
                            :value="syncResponse.actions"
                            :expanded="true"
                            :expand-depth="20"
                            :show-array-index="false"
                            show-double-quotes
                            copyable
                            boxed
                            sort></json-viewer>
                    </div>
                    <div class="text-right mt-2">
                        <button @click="showDetails=!showDetails" class="btn btn-secondary btn-sm">
                            Voir les informations détaillées
                        </button>
                    </div>
                </div>
                <div v-if="syncResponse.actions && syncResponse.actions.products && syncResponse.actions.products._error">
                    <div class="alert alert-danger">
                        Synchronisation Cérès vers {{ syncList[typeLoading].join(' ') }} : Une erreur est survenue
                        pendant la synchronisation :<br />
                        <i>{{ syncResponse.message }}</i>
                        <div v-if="syncResponse.workaround === 'display_manual_actions'" class="mt-4">
                            La synchronisation automatique est impossible.<br/>
                            Voici la liste des actions manuelles à faire : <br/>
                            <div class="card text-dark" style="background-color: #fafafa; font-size: 87.5%;">
                                <div class="m-4">
                                    <div class="mb-2 text-danger" v-if="typeLoading === 'thefoodassembly'">
                                        Attention, vous devez vous assurer qu'aucun
                                        <a target="_blank"
                                           href="https://laruchequiditoui.fr/fr/producers/me/interregional-products/stocks">
                                            produit inter-régional
                                            ("Produits envoyés")
                                            <i class="fad fa-external-link"></i>
                                        </a>
                                        n'est présent sur le site de la Ruche avant toute utilisation de cet outil.
                                    </div>
                                    <div class="mb-2 text-danger">
                                        Attention, chaque produit ne peut avoir qu'une seule offre/déclainaison.<br/>
                                        Si un produit possdèe plusieurs offres/déclinaisons, cette page pourrait afficher de
                                        mauvaises informations.<br/>
                                        Vous devez tout d'abord vérifier que chaque produit ne posède qu'une seule et unique
                                        offre/déclinaison.
                                    </div>
                                    <div class="mb-2 text-danger">
                                        Attention, les produits à créer/supprimer peuvent être identiques en raison d'une
                                        mauvaise identification.<br/>
                                        Il est recommandé de commencer par vérifier le SKU des produits (en particulier les
                                        produits à supprimer) avant de créer de nouveaux produits.
                                    </div>
                                    <div v-for="(actions, itemType) in syncResponse.actions">
                                        <div class="mt-2" v-for="(items, actionName) in actions" v-if="actionName !== '_error'">
                                            {{ getTranslatedValue(null, itemType) | capitalize }} à {{ getTranslatedValue(null, actionName) }} :
                                            <div class="ml-4" v-for="(item, key) in items">
                                                <div v-if="actionName === 'delete'">
                                                    [{{ key }}]
                                                    {{ item.name ? item.name : item.nom }}
                                                    -
                                                    <a :href="item.__product_link"
                                                       class="text-warning" target="_blank" rel="noopener noreferrer">
                                                        <i class="fad fa-external-link"></i>
                                                        {{ syncList[typeLoading].join(' ') }}
                                                    </a>
                                                </div>
                                                <div v-if="actionName === 'update'">
                                                    [{{ item.__sellsy_product.sku }}]
                                                    {{ item.name ? item.name : item.nom }}
                                                    <span class="text-muted font-italic">
                                                        ({{ item.__update_on.length }} champs)
                                                    </span>
                                                    -
                                                    <a href=""
                                                       @click.prevent="toggleManual(`${itemType}-${actionName}-${item.__sellsy_product.sku}`)">
                                                        <i class="fad fa-search"></i> Voir les valeurs
                                                    </a>
                                                    -
                                                    <a :href="item.__product_link"
                                                       class="text-warning" target="_blank" rel="noopener noreferrer">
                                                        <i class="fad fa-external-link"></i>
                                                        {{ syncList[typeLoading].join(' ') }}
                                                    </a>
                                                    <div class="ml-4" v-for="field in item.__update_on"
                                                         v-show="showManual[`${itemType}-${actionName}-${item.__sellsy_product.sku}`]">
                                                        Champ à modifier :
                                                        {{ field.field }} ({{ getTranslatedValue(null, field.field) }})
                                                        <div class="ml-4">
                                                            <div class="text-danger small"
                                                                 v-if="typeLoading === 'thefoodassembly' && field.field === 'type'">
                                                                Modifier la valeur de ce champ impose de supprimer et re-créer
                                                                le produit
                                                            </div>
                                                            <div class="text-danger small"
                                                                 v-if="typeLoading === 'thefoodassembly' && field.field === 'taxRate-0-amount'">
                                                                Modifier la valeur de ce champ impose de supprimer et re-créer
                                                                le produit dans une catégorie différente
                                                            </div>
                                                            Valeur actuelle :
                                                            <div class="ml-4">
                                                                <div class="text-code">
                                                                    <a v-if="typeof field.before === 'string' && (field.before.startsWith('http://') || field.before.startsWith('https://'))" :href="field.before" target="_blank" rel="noopener noreferrer">
                                                                        <i class="fad fa-external-link"></i> {{ field.before }}
                                                                    </a>
                                                                    <span v-else-if="typeof field.before === 'string'" v-html="nl2br(field.before)"></span>
                                                                    <span v-else-if="typeof field.before !== 'string'">
                                                                        {{ field.before === null ? 'null' : field.before }}
                                                                    </span>
                                                                    <span class="text-muted font-italic"
                                                                          v-if="field.before !== getTranslatedValue(field.field, field.before)">
                                                                        ({{ getTranslatedValue(field.field, field.before) }})
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            Valeur attendue :
                                                            <div class="ml-4">
                                                                <div class="text-code">
                                                                    <a v-if="typeof field.after === 'string' && (field.after.startsWith('http://') || field.after.startsWith('https://'))" :href="field.after" target="_blank" rel="noopener noreferrer">
                                                                        <i class="fad fa-external-link"></i> {{ field.after }}
                                                                    </a>
                                                                    <span v-else-if="typeof field.after === 'string'" v-html="nl2br(field.after)"></span>
                                                                    <span v-else-if="typeof field.after !== 'string'">
                                                                        {{ field.after === null ? 'null' : field.after }}
                                                                    </span>
                                                                    <span class="text-muted font-italic"
                                                                          v-if="field.after !== getTranslatedValue(field.field, field.after)">
                                                                        ({{ getTranslatedValue(field.field, field.after) }})
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="actionName === 'create'">
                                                    [{{ item.__sellsy_product.sku }}]
                                                    {{ item.name ? item.name : item.nom }}
                                                    -
                                                    <a href=""
                                                       @click.prevent="toggleManual(`${itemType}-${actionName}-${item.__sellsy_product.sku}`)">
                                                        <i class="fad fa-search"></i> Voir les valeurs
                                                    </a>
                                                    <div class="ml-4" v-for="(value, key) in item"
                                                         v-if="key !== 'uuid' && key !== 'local' && key !== '__sellsy_product'"
                                                         v-show="showManual[`${itemType}-${actionName}-${item.__sellsy_product.sku}`]">
                                                        Champ : {{ getTranslatedValue(null, key) }} ({{ key }})<br/>
                                                        <div class="ml-4">
                                                            <div class="text-code">
                                                                <span v-if="typeof value === 'string'" v-html="nl2br(value)"></span>
                                                                <span v-if="typeof value !== 'string'">
                                                                    {{ value === null ? 'null' : value }}
                                                                </span>
                                                                <span class="text-muted font-italic"
                                                                      v-if="value !== getTranslatedValue(key, value)">
                                                                    ({{ getTranslatedValue(key, value) }})
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right mt-2">
                        <button @click="showDetails=!showDetails" class="btn btn-secondary btn-sm">
                            Voir les informations détaillées
                        </button>
                    </div>
                </div>
                <div v-if="showDetails">
                    Informations détaillées : <br/>
                    <div class="card" style="background-color: #fafafa">
                        <json-viewer
                            :value="syncResponse"
                            :expanded="true"
                            :expand-depth="20"
                            :show-array-index="false"
                            show-double-quotes
                            copyable
                            boxed
                            sort></json-viewer>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="products && products.products && !errors">
            <div class="card">
                <table class="table table-sm mb-0 table-responsive text-nowrap">
                    <thead class="thead-light">
                        <tr>
                            <th></th>
                            <th></th>
                            <th>SKU</th>
                            <th>Stock</th>
                            <th>Magasins</th>
                            <th>Marchés</th>
                            <th>Caisse <br />Fournil</th>
                            <th v-for="(is_default, brand) in brands" :key="brand" :title="`Site web ${brand}`">
                                Site web <br /><small>{{ brand }}</small>
                            </th>
                            <th>Circuits <br />courts</th>
                            <th>Groupes<br />de clients</th>
                            <th>Détails</th>
                            <th>Nom</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product, sku) in products.products">
                            <td :title="sku">
                                <span v-if="product.image && product.image.url">
                                    <img :src="getProductImageUrl(product.image.url)" :title="product.image.name" alt="" height="72px" width="72px">
                                </span>
                            </td>
                            <td :title="sku">
                                <img :src="getProductImageUrl(image.url)" :title="image.name" alt="" class="d-block" height="36px" width="36px" v-if="i !== 0" v-for="(image, i) in product.images">
                            </td>
                            <td :title="`${sku} : SKU`">
                                {{ sku }}<br />
                                {{ product.brand }}<br />
                                <img :src="getProductImageUrl(product.categoryImage.url)" :title="product.categoryImage.name" alt="" height="24px" width="24px">
                                <i :title="product.mainCategory">{{ product.category }}</i><br />
                                <small class="text-info" v-if="product.potentialSellingInconsistency" title="Potentielle incohérence de disponibilité : le produit n'a pas une disponibilité équivalente dans tous les canaux de vente">
                                    <i class="fad fa-exclamation-triangle"></i> Potentielle incohérence de dispo.
                                </small>
                            </td>
                            <td :title="`${sku} : Stock`">
                                <span class="text-success" v-if="product.stockState !== 'soldout'">En stock</span>
                                <span class="text-warning" v-if="product.stockState === 'soldout'">Rupture</span>
                                <br />
                                <small>
                                    <i class="text-muted">
                                        {{ product.stockState === 'unlimited' ? 'Illimité' : 'Stock : ' + product.stockQuantity }}<br />
                                        <span v-if="product.stockDate">
                                            Dispo :<br />
                                            {{ formatDate(product.stockDate.date) }}
                                        </span>
                                    </i>
                                </small>
                            </td>
                            <td :title="`${sku} : Magasins`">
                                <span class="text-success" v-if="product.isSoldInStores">Oui</span>
                                <span class="text-warning" v-if="!product.isSoldInStores">Non</span>
                                <br />
                                <strong>{{ product.storesPrice }}€<small>HT{{ product.unit ? '/'+product.unit : '' }}</small></strong><br />
                                <small><span title="Prix de vente conseillé">Conseil.:</span> <i>{{ product.advisedPrice }}€<small>TTC{{ product.unit ? '/'+product.unit : '' }}</small></i></small>
                            </td>
                            <td :title="`${sku} : Marchés`">
                                <span class="text-success" v-if="product.isSoldOnMarkets">Oui</span>
                                <span class="text-warning" v-if="!product.isSoldOnMarkets">Non</span>
                                <br />
                                <strong>{{ product.marketsPrice }}€<small>TTC{{ product.unit ? '/'+product.unit : '' }}</small></strong>
                            </td>
                            <td :title="`${sku} : Caisse Fournil`">
                                <span class="text-success" v-if="product.isSoldOnBakery">Oui</span>
                                <span class="text-warning" v-if="!product.isSoldOnBakery">Non</span>
                                <br />
                                <strong>{{ product.bakeryPrice }}€<small>TTC{{ product.unit ? '/'+product.unit : '' }}</small></strong><br />
                                <span v-for="(price, day) in product.bakeryPriceByDay" :key="day">
                                    <small>{{ day }}: </small><strong>{{ price }}€<small>TTC{{ product.unit ? '/'+product.unit : '' }}</small></strong><br />
                                </span>
                            </td>
                            <td v-for="(is_default, brand) in brands" :key="brand" :title="`${sku} : Site web ${brand}`">
                                <template v-if="brand === product.brand">
                                    <span class="text-success" v-if="product.isSoldOnWebsite">Oui</span>
                                    <span class="text-warning" v-if="!product.isSoldOnWebsite">Non</span>
                                    <i class="text-muted">
                                        <template v-if="product.weight">{{ product.weight }}g</template>
                                        <span class="text-danger" v-if="!product.weight && product.unit && product.unit !== '€'">???g</span>
                                    </i><br />
                                    <strong>{{ product.websitePrice }}€</strong>
                                    <small><i class="text-muted">
                                        <template v-if="product.priceWeight">
                                            ({{ product.priceWeight }}g)
                                        </template>
                                        <span class="text-danger" v-if="!product.priceWeight && product.unit && product.unit !== '€'">???g</span>
                                        <span class="text-info" v-if="!product.unit" title="Produit à l'unité">(u)</span>
                                    </i></small><br />
                                    <small>
                                        <span title="Réduction pour un retrait au fournil">Sacq.: </span>
                                        <i>{{ round(product.websiteBakeryPrice, 2) }}€</i>
                                    </small>
                                </template>
                                <template v-if="brand !== product.brand">
                                    <span class="text-info">Non</span><br />
                                    <small class="text-muted" :title="`Non applicable : Activité ${product.brand}`">(N/A)</small>
                                </template>
                            </td>
                            <td :title="`${sku} : Circuits courts`">
                                <span class="text-success" v-if="product.isSoldOnShortChannels">Oui</span>
                                <span class="text-warning" v-if="!product.isSoldOnShortChannels">Non</span>
                                <i class="text-muted">
                                    <template v-if="product.weight">{{ product.weight }}g</template>
                                    <span class="text-danger" v-if="!product.weight && product.unit && product.unit !== '€'">???g</span>
                                </i><br />
                                <strong>{{ product.shortChannelsPrice }}€</strong>
                                <small><i class="text-muted">
                                    <template v-if="product.priceWeight">
                                        ({{ product.priceWeight }}g)
                                    </template>
                                    <span class="text-danger" v-if="!product.priceWeight && product.unit && product.unit !== '€'">???g</span>
                                    <span class="text-info" v-if="!product.unit" title="Produit à l'unité">(u)</span>
                                </i></small><br />
                                <small>
                                    <span title="Comission">Comm.: </span>
                                    <i>{{ product.shortChannelsPriceFees }}</i>
                                </small>
                            </td>
                            <td :title="`${sku} : Groupements de clients`">
                                <span class="text-success" v-if="product.isSoldByCustomerGroups">Oui</span>
                                <span class="text-warning" v-if="!product.isSoldByCustomerGroups">Non</span>
                                <i class="text-muted">
                                    <template v-if="product.weight">{{ product.weight }}g</template>
                                    <span class="text-danger" v-if="!product.weight && product.unit && product.unit !== '€'">???g</span>
                                </i><br/>
                                <strong>{{ product.customerGroupsPrice }}€</strong>
                                <small><i class="text-muted">
                                    <template v-if="product.priceWeight">
                                        ({{ product.priceWeight }}g)
                                    </template>
                                    <span class="text-danger" v-if="!product.priceWeight && product.unit && product.unit !== '€'">???g</span>
                                    <span class="text-info" v-if="!product.unit" title="Produit à l'unité">(u)</span>
                                </i></small><br/>
                            </td>
                            <td :title="`${sku} : Détails`">
                                <template v-if="product.unit"><strong>Unité :</strong> {{ product.unit }}</template>
                                <i class="text-muted" v-if="!product.unit">A l'unité</i>
                                <br />
                                <strong>TVA : </strong>{{ product.taxrate }}%<br />
                                <strong title="Code-barres">Code : </strong>
                                <i class="text-muted">
                                    <a v-if="product._suggestedBarcode" href="" title="Suggestion de code-barres"
                                       @click.prevent="global.alert(`Suggestion de code-barres pour le produit ${sku}: ${product._suggestedBarcode}`)">
                                        <i class="fad fa-info-circle"></i>
                                    </a>
                                    <template v-if="!product._suggestedBarcode && product.barcode">{{ product.barcode }}</template>
                                    <a v-if="!product._suggestedBarcode && !product.barcode" href="" title="Suggestion de code-barres"
                                       @click.prevent="global.alert('Impossible de suggèrer un code-barres pour ce produit, aucun code-barres disponible')">
                                        <i class="fad text-warning fa-exclamation-circle"></i>
                                    </a>
                                </i>
                            </td>
                            <td :title="`${sku} : Nom`">
                                <strong>Nom <small class="text-muted font-italic">(Click & Collect, Cérès)</small> : </strong>
                                <template v-if="product.name">{{ product.name }}</template>
                                <i class="text-danger" v-if="!product.name">Nom manquant</i>
                                <br />
                                <strong>Très court <small class="text-muted font-italic">(Ruche, Locavor, Cérès)</small> : </strong>
                                <template v-if="product.shortShortName">{{ product.shortShortName }}</template>
                                <i class="text-danger" v-if="!product.shortShortName">Manquant</i>
                                <br />
                                <strong>Très très court <small class="text-muted font-italic">(Zettle, Cérès)</small> : </strong>
                                <template v-if="product.tinyName">{{ product.tinyName }}</template>
                                <i class="text-danger" v-if="!product.tinyName">Manquant</i>
                                <br />
                                <div class="bg-danger px-1 text-white" v-if="product.errors">
                                    <template v-for="(error, errorType) in product.errors">
                                        <div v-bind:key="errorType">ERREUR : {{ error }}</div>
                                    </template>
                                </div>
                            </td>
                            <td :title="`${sku} : Description`">
                                <span v-if="product.description" v-html="product.description"></span>
                                <i class="text-danger" v-if="!product.description">Description manquante</i>
                                <br />
                                <strong>Ingrédients : </strong>
                                <template v-if="product.ingredients">{{ product.ingredients }}</template>
                                <i class="text-danger" v-if="!product.ingredients">Manquant</i>
                                -
                                <small><i class="text-muted">* Ingrédients issus de l\'agriculture biologique</i></small>
                                <br />
                                <strong>Conservation : </strong>
                                <template v-if="product.storageDays">{{ product.storageDays }} jours</template>
                                <i class="text-danger" v-if="!product.storageDays">Manquant</i>
                                -
                                <strong>Allergènes : </strong>
                                <template v-if="product.allergens">{{ product.allergens }}</template>
                                <i class="text-warning" v-if="!product.allergens">Sans</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
</template>

<script>
import ErrorsZone from "./ErrorsZone";
import LoadingScreen from "./LoadingScreen";
import {useGetLoader} from "./compositions/axios/loadingRequest";
import {momentDay} from "../moment-with-helpers";
import JsonViewer from 'vue-json-viewer/ssr'
import 'vue-json-viewer/style.css'


export default {
    name: 'SyncLegacyPage',

    components: {
        ErrorsZone,
        LoadingScreen,
        JsonViewer,
    },

    props: {
        brands: {
            type: Object,
            required: true,
        },
        syncList: {
            type: Object,
            required: true,
        },
        locavorCategories: {
            type: Object,
            required: true,
        },
        thefoodassemblyCategories: {
            type: Object,
            required: true,
        },
    },

    setup() {
        const {
            loaded,
            loading,
            errors,
            load,
        } = useGetLoader();

        return {
            loaded,
            loading,
            errors,
            load,
        };
    },

    data() {
        let translations = {
            'products': 'produits',
            'create': 'créer',
            'update': 'mettre à jour',
            'delete': 'supprimer',
            'null': 'aucun/indéfini',
            'true': 'vrai/oui',
            'false': 'faux/non',
            'empty': 'vide',

            // TFA
            'name': 'nom',
            'description': 'description',
            'scope': 'zone de distribution',
            'scope_local': 'produits remis',
            'scope_interregional': 'produits envoyés',
            'undeliveredHives': 'ruches interdites pour ce produit',
            'allergens': 'allergènes',
            'allergens_sulphur-dioxide': 'Anhydride sulfureux',
            'allergens_peanut': 'Arachides',
            'allergens_celery': 'Céleri',
            'allergens_crustacean': 'Crustacé',
            'allergens_tree-nut': 'Fruits à coques',
            'allergens_gluten': 'Gluten',
            'allergens_sesame-seed': 'Graines de sésames',
            'allergens_milk': 'Lait',
            'allergens_lupin': 'Lupin',
            'allergens_mollusc': 'Mollusques',
            'allergens_mustard': 'Moutarde',
            'allergens_egg': 'Oeufs',
            'allergens_fish': 'Poisson',
            'allergens_soybean': 'Soja',
            'freshness': 'garantie fraîcheur',
            'storageLife': 'conservation garantie',
            'type': 'type de produit',
            'labels': 'labels',
            'taxRate': 'taux de TVA',
            'offer': 'offres',
            'quantityUnit': 'unité',
            'quantityStrategy': 'stratégie de quantité',
            'quantityStrategy_weight': 'poids total',
            'quantityStrategy_both': 'poids par pièce',
            'quantityStrategy_unit': 'pièce',
            'uuid': 'identifiant du produit',

            // TFA Specific
            // type_id Injected automatically after
            'labels_176': 'Agriculture Biologique',

            // Locavor
            'refpro0': 'référence',
            'idcat': 'catégorie',
            'idscat': 'sous-catégorie',
            'image-principale': 'image principale',
            'nom': 'nom',
            'quantite0': 'poids/quantité',
            'typequantite0': 'type de poids/quantité',
            'prix0': 'prix de vente',
            'usestock0': 'gestion stock',
            'bio': 'bio',
            'surgele': 'surgelé',
            'ingred': 'ingrédients',
            'origin': 'origine',
            'durcons': 'durée de conservation',
            'allergenes': 'allergènes',
            'condit': 'conditionnement',
            'color': 'colorants ou arômes',
            'prevente': 'prévente',
            'seomanuel': 'référencement',
            'suprr': 'produit non disponible',
            'tva': '% tva',
            'mise_en_avant': 'mise en avant',

            // Locavor Specific
            'typequantite0_g': 'Grammes',
            'typequantite0_u': 'Unité',
            // idcat_id & idscat_id Injected automatically after
            'suppr_0': 'Disponible',
            'suppr_1': 'Non disponible',
            'usestock0_0': 'Sans',
            'usestock0_1': 'Mutualisé',
            'usestock0_2': 'Par locavor',
        };
        // Locavor Specific
        for (let key in this.locavorCategories) {
            let keySplit = key.split(':');
            let category = keySplit[0];
            let subcategory = keySplit[1];
            let nameSplit = this.locavorCategories[key].split(' > ');
            translations['idcat_'+category] = nameSplit[0];
            translations['idscat_'+subcategory] = this.locavorCategories[key];
        }

        // TFA Specific
        for (let key in this.thefoodassemblyCategories) {
            translations['type_'+key] = this.thefoodassemblyCategories[key];
        }

        return {
            loadedOnce: false,
            syncResponse: null,
            products: null,
            typeLoading: null,
            showDetails: false,
            translations: translations,
            showManual: {},
        };
    },

    filters: {
        pretty: function(value) {
            return JSON.stringify(value, null, 2);
        },
        capitalize: function(value) {
            return (typeof value === 'string' && value.length > 0) ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : value;
        },
    },

    methods: {
        getProductImageUrl(url) {
            return url.replace(/^https:\/\/file\.sellsy\.com\//, '/espace-employes/sync/legacy/produit/image');
        },

        toggleManual(key) {
            this.$set(this.showManual, key, !this.showManual[key]);
            return false;
        },

        nl2br(value) {
            if (typeof value !== 'string')
                return value;
            let breakTag = '<br />';
            return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },

        resetBeforeSync(type) {
            this.syncResponse = null;
            this.products = null;
            this.typeLoading = type;
            this.showDetails = false;
            this.showManual = {};
        },

        async syncNow(type) {
            this.resetBeforeSync(type);
            const data = await this.load(`/espace-employes/sync/legacy/${type}/json`);
            if (data) {
                this.syncResponse = data;
                this.loadedOnce = true;
            }
        },

        async showProducts() {
            this.resetBeforeSync('products');
            const data = await this.load(`/espace-employes/sync/legacy/produits/json`);
            if (data) {
                this.products = data;
                this.loadedOnce = true;
            }
        },

        _getTranslatedValue(key, value) {
            if (value === null) {
                value = 'null';
            } else if (value === true) {
                value = 'true';
            } else if (value === false) {
                value = 'false';
            } else if (value === '') {
                value = 'empty';
            }
            let filterKeys = [key + '_' + value, value + ''];
            for (let i in filterKeys) {
                let filterKey = filterKeys[i];
                let filtered = this.translate(filterKey);
                if (filtered !== filterKey) {
                    return filtered;
                }
            }
            return value;
        },

        getTranslatedValue(key, value) {
            if (Array.isArray(value)) {
                let _values = [];
                for (let i in value) {
                    let _value = value[i];
                    if (typeof _value == 'object')
                        return this._getTranslatedValue(key, value);
                    _values.push(this._getTranslatedValue(key, _value));
                }
                return _values;
            }
            return this._getTranslatedValue(key, value);
        },


        translate(value) {
            if (typeof value !== 'string')
                return value;
            if (!value) {
                return '';
            }
            if (this.translations[value]) {
                return this.translations[value];
            }
            return value;
        },

        formatDate(date) {
            return momentDay(date).format('D/MM/Y');
        },

        round(value, precision) {
            if (typeof value !== 'number')
                return value;
            if (typeof precision !== 'number')
                precision = 2;
            return Math.round((value + Number.EPSILON) * Math.pow(10, precision)) / Math.pow(10, precision);
        },
    },
}
</script>

<style lang="scss" scoped>
.sync-legacy-page {
    .table-sm {
        font-size: 0.75rem;
        line-height: 1.1rem;
        font-family: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
    }
}
</style>
